import { BorderColor } from '@mui/icons-material';
import usePropertyRequestsStore from 'store/propertyRequestsStore';
import { DEFAULT_REGION } from 'types/Region';
import AppliedFilters from './AppliedFilters';

export default function SavedFilters() {
    const { savedFilters, setPropertyRequestQueryFilter, setRegion } = usePropertyRequestsStore();

    const handleSaveFilterClick = (title: string) => {
        setPropertyRequestQueryFilter({});
        setRegion(DEFAULT_REGION);
        const filter = savedFilters.find((f) => f.title === title);

        if (filter) {
            setTimeout(() => {
                setPropertyRequestQueryFilter(filter.filters);
                setRegion({ name: filter.filters.propertyCountry, citiesAndStates: [], nonCitiesAndStates: [] });
            }, 0);
        }
    };

    if (savedFilters.length === 0) return null;

    return (
        <>
            <div className="mt-6  items-center md:flex flex-wrap hidden">
                <h4 className="font-poppins text-base mt-2">Saved:</h4>
                <AppliedFilters
                    Icon={BorderColor}
                    options={savedFilters.map((filter: Record<string, any>) => ({ type: filter.title, text: filter.title }))}
                    onSaveFilterClick={handleSaveFilterClick}
                    isSavedFilter={true}
                />
            </div>
        </>
    );
}
